import axios from 'axios';

class awsService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V;
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    });

    this.apiClient.interceptors.request.use(config => {
      //   const token = JSON.parse(localStorage.getItem('loginInfonetApp'))?.token || '';
      //   console.log(token)
      const token = localStorage.getItem("accesstoken");
      config.headers['x-auth-token'] = token;
      return config;
    }, error => {
      return Promise.reject(error);
    });
  }

  async getawss(data) {
    const response = await this.apiClient.post('/aws/list', data);
    return response.data.data;
  }
  async getavailablebuckets(data) {
    const response = await this.apiClient.post('/aws/getbucketlist', data);
    return response.data.data;
  }

  async getdblistData(data) {
    const response = await this.apiClient.post('/dblist', data);
    return response.data.data;
  }

  async getavailablefolders(data) {
    const response = await this.apiClient.post('/aws/getfolderlist', data);
    return response.data.data;
  }
  async gethtmlpackagelist(data) {
    const response = await this.apiClient.post('/aws/gethtmlpackagelist', data);
    return response.data.data;
  }
  async getavailablefoldersforuser(data) {
    const response = await this.apiClient.post('/aws/getfolderlistforuser', data);
    return response.data.data;
  }
  async createFolder(data) {
    const response = await this.apiClient.post('/aws/createfolder', data)
    // const response = await this.apiClient.post('/aws/getfolderlistforuser',data);
    return response.data;
  }
  async gethtmlindex(data) {
    const response = await this.apiClient.post('/aws/gethtmlindex', data);
    return response.data.data;
  }


  // async createFolder(data) {
  //   const response = await this.apiClient.post('/aws/createfolder', data)
  //   return response.data.data;

  // }


  async uploadFile(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/uploadFile', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }
  async replaceFile(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/replaceFile', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }

  async replaceVideoFile(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/replacevideo', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }


  async replaceUserFile(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/replaceFileuser', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }
  async uploadFileHtml(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/uploadFileHtml', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }
  async uploadFileVideos(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/uploadvideo', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }
  async uploadFileUser(data) {
    this.apiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    const response = await this.apiClient.post('/aws/uploadFileuser', data, {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        // Update UI with the progress percentage
      }
    });
    this.apiClient.defaults.headers.common['Content-Type'] = 'application/json'

    return response.data.data;

  }
  async downloadFile(data) {
    const response = await this.apiClient.post('/aws/downloadFile', data);

    return response.data.data;

  }
  async downloadFolder(data) {

    const response = await this.apiClient.post('/aws/downloadFolder', data, {
      responseType: 'blob', // Important for downloading files
    });

    return response.data;

  }
  async downloadHtmlFile(data) {
    const response = await this.apiClient.post('/aws/downloadhtmlFile', data);

    return response.data.data;

  }
  async downloadFileUser(data) {
    const response = await this.apiClient.post('/aws/downloadFileuser', data);

    return response.data.data;

  }

  async downloadFolderuser(data) {
    const response = await this.apiClient.post('/aws/downloadFolderuser', data, {
      responseType: 'blob',
    });

    return response.data;

  }

  async PreviewUrlUser(data) {
    const response = await this.apiClient.post('/previewuserfile', data, {
      responseType: 'blob',
    });

    return response.data;

  }

  async PreviewUrl(data) {
    const response = await this.apiClient.post('/previewfile', data, {
      responseType: 'blob',
    });

    return response.data;

  }

  async PreviewVideo(data) {
    const response = await this.apiClient.post('/previewvideo', data);

    return response.data.data;

  }
  async UserPreviewVideo(data) {
    const response = await this.apiClient.post('/userpreviewvideo', data);

    return response.data.data;

  }
  async addaws(aws) {
    const response = await this.apiClient.post('/awscreate', aws);
    return response.data.data;
  }

  async updateaws(id, aws) {
    const response = await this.apiClient.put(`/awsupdate/${id}`, aws);
    return response.data;
  }

  async deleteaws(id) {
    const response = await this.apiClient.delete(`/awsdelete/${id}`);
    return response.data;
  }
  async updateDBUpload(data) {
    const response = await this.apiClient.post('/updatedbupload', data);
    return response.data.data;
  }
  async reloadDb(data) {
    const response = await this.apiClient.post('/s3recurse', data);
    return response;
  }

  async reanameFile(data) {

    const response = await this.apiClient.post('/aws/renamefile', data);

    return response.data;

  }
  async reanameVideoFile(data) {

    const response = await this.apiClient.post('/aws/renameVideoFile', data);

    return response.data;

  }
  async reanameFolder(data) {

    const response = await this.apiClient.post('/aws/renamefolder', data);

    return response.data;

  }

  async deleteFile(data) {
    const response = await this.apiClient.post('/aws/deletefile', data);
    return response.data;
  }

  async deleteVideo(data) {
    const response = await this.apiClient.post('/aws/deletevideofile', data);
    return response.data;
  }

  async getVideoList(data) {
    const response = await this.apiClient.post('/aws/getvideolist', data);
    return response.data.data;
  }

}




// eslint-disable-next-line import/no-anonymous-default-export
export default new awsService();